import { Mappable } from './mappable';

export class DbEnumeration extends Mappable {
  code: string;
  description: number;

  constructor() { super() }
}
